import React from 'react';
import styled, { css } from 'styled-components';

const StyledCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #2e92fd;
  padding: 16px;
  border-radius: 4px;
  max-width: 400px;
  min-height: 150px;
  width: 100%;

  h1 {  
    font-size: 12px;
    font-weight: 600;
    color: #2e92fd;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
    color: #ea1f6a;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: #203660;
  }

  ${({ disabled }) => disabled && css`
    h1, h2, p, span {
      color: gray;
      text-decoration: line-through;
    }
  `}

  ${({ hideOnMobile }) => hideOnMobile && css`
    @media (max-width: 768px) {
      display: none;
    }
  `}

  @media (max-width: 768px) {
    h1, h2, p {
      text-align: center;
    }
  }
`;

export const CardInfo = ({ title, description, subtitle, disabled, hideOnMobile }) => {
  return (
    <StyledCardInfo disabled={disabled} hideOnMobile={hideOnMobile}>
      <h1>{title}</h1>
      <h2>{subtitle}</h2>
      <p>{description}</p>
    </StyledCardInfo>
  );
};
